import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

interface AdminRouteProps {
  children: React.ReactNode
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { user, loading, _hasHydrated } = useAuth()
  const location = useLocation()

  // Show loading while store is hydrating or authentication is in progress
  if (!_hasHydrated || loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        backgroundColor: 'var(--surface-secondary)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          border: '4px solid var(--brand-primary)',
          borderTop: '4px solid transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
      </div>
    )
  }

  // If no user, redirect to admin login
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />
  }

  // Check if user has ADMIN role
  if (!user.roles?.includes('ADMIN')) {
    // Regular users shouldn't know admin area exists - redirect to home
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}